<script>
  export let uncalled = 0;
  export let compact = false;
</script>

<div
  class="governor-key"
  class:governor-key--complete={uncalled === 0}
  class:text-base={!compact}
  class:text-sm={compact}
  aria-hidden="true"
>
  {#if uncalled > 0}
    <span class="governor-key__uncalled">
      <span class="governor-key__count">
        <strong>{uncalled}</strong>
        {uncalled === 1 ? 'race' : 'races'}
      </span>
      uncalled
    </span>

    <svg
      class="governor-key__empty"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      aria-hidden="true"
    >
      <rect
        x="2"
        y="2"
        width="36"
        height="36"
        fill="#fff"
        stroke="#777"
        stroke-width="4"
      />
    </svg>
  {/if}

  <svg
    class="governor-key__filled"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="2"
      width="36"
      height="36"
      fill="#cecccc"
      stroke="#777"
      stroke-width="4"
    />

<path
  d="M38 12H62 M20 28H62"
  fill="none"
  stroke="#222"
  stroke-width="1.5"
/>
  </svg>

  <div class="governor-key__annotations">
    <span>Current seat</span>
    <span>Winner</span>
  </div>

  <span class="governor-key__no-contest">
    <span>No</span>
    <span>contest</span>
  </span>

  <svg
    class="governor-key__dem"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    aria-hidden="true"
  >
    <rect width="40" height="40" />
  </svg>

  <svg
    class="governor-key__gop"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    aria-hidden="true"
  >
    <rect width="40" height="40" />
  </svg>
</div>